(() => {
  const rootSelector = '[data-lc-spot-68-variant-media]';
  const imageSelector = '[data-lc-spot-variant-image]';

  const colorKeyForValue = (value) => {
    const normalized = String(value || '').trim().toLocaleLowerCase('de-DE');
    if (normalized === 'schwarz' || normalized === 'black') return 'black';
    if (normalized === 'weiß' || normalized === 'weiss' || normalized === 'white') return 'white';
    return null;
  };

  const colorKeyForVariant = (variant) => {
    if (!variant) return null;
    return colorKeyForValue(variant.option1 || variant.options?.[0]);
  };

  const colorKeyForRootVariant = (root, variant) => {
    const variantId = String(variant?.id || '');
    if (!variantId) return null;
    if (variantId === root.dataset.lcSpotBlackVariantId) return 'black';
    if (variantId === root.dataset.lcSpotWhiteVariantId) return 'white';
    return null;
  };

  const applyColor = (root, value) => {
    const color = value === 'black' || value === 'white' ? value : colorKeyForValue(value);
    if (!color) return false;

    root.querySelectorAll(imageSelector).forEach((image) => {
      const prefix = color === 'white' ? 'lcSpotWhite' : 'lcSpotBlack';
      const source = image.dataset[`${prefix}Src`];
      const alt = image.dataset[`${prefix}Alt`];
      if (source) image.src = source;
      if (alt) image.alt = alt;
      image.dataset.lcSpotActiveColor = color;
    });

    root.dataset.lcSpotActiveColor = color;
    return true;
  };

  const applyVariant = (variant) => {
    let applied = false;
    document.querySelectorAll(rootSelector).forEach((root) => {
      const color = colorKeyForRootVariant(root, variant);
      if (color) applied = applyColor(root, color) || applied;
    });
    return applied;
  };

  const initialize = () => {
    document.querySelectorAll(rootSelector).forEach((root) => {
      applyColor(root, root.dataset.lcSpotInitialColor);
    });
    document.addEventListener('variant:changed', (event) => applyVariant(event.detail?.variant));
  };

  window.LCSpot68VariantMedia = {
    applyColor,
    applyVariant,
    colorKeyForVariant,
    colorKeyForRootVariant,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
